import { getRoleProp, RoleProp } from "constant/user-list";
import { get, isArray } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Link, Redirect } from "react-router-dom";
import * as Users from "redux-store/users/selectors";
import { NavLoader } from "ui/loader";
import { Table, Column } from "ui/table";
import { sortByProp } from "util/sort-by-prop";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";
import { VIEW } from "view/views";

function UserRole(props) {
  const { roleProp } = props;

  return (
    <span className={`label bg-${roleProp.labelColor}`}>{roleProp.label}</span>
  );
}

UserRole.propTypes = { roleProp: RoleProp.isRequired };

class UserListPage extends React.PureComponent {
  static get propTypes() {
    return {
      users: PropTypes.array.isRequired,
      networks: PropTypes.object.isRequired,
      isAdmin: PropTypes.bool.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      user: PropTypes.object,
      currentUser: PropTypes.object,
    };
  }

  static _sortAccessLevel(_u1, _u2, order = "asc", _field, rowA, rowB) {
    return sortByProp("label", order, getRoleProp(rowA), getRoleProp(rowB));
  }

  constructor() {
    super();

    this.tableOpts = {
      sortName: "id",
      sortOrder: "desc",
    };

    this._formatNetworks = this._formatNetworks.bind(this);
  }

  _formatOperations(_, user) {
    return (
      <div>
        <Link
          className="btn btn-default btn-sm"
          to={`/users/${user.id}/${VIEW.EDIT}`}
        >
          <i className="fa fa-edit" /> Edit
        </Link>
      </div>
    );
  }

  _formatRole(_, user) {
    return <UserRole roleProp={getRoleProp(user)} />;
  }

  _formatNetworks(_, user) {
    const { networks } = this.props;
    if (!user) {
      return null;
    }

    if (Users.isAdmin(user)) {
      return "All networks";
    }

    const userNetworks = user.networks
      .map((networkId) => networks[networkId])
      .filter((n) => n)
      .map((n) => {
        const { id, name } = n;

        return (
          <li key={id}>
            <Link to={`/networks/${id}`}>{name}</Link>
          </li>
        );
      });

    return <ul className="list-unstyled">{userNetworks}</ul>;
  }

  _renderColumns() {
    const { isAdmin } = this.props;

    const columns = [
      <Column key="id" dataField="id" isKey={true} hidden={true}>
        ID
      </Column>,
      <Column key="name" dataField="name" dataSort={true}>
        Name
      </Column>,
      <Column key="email" dataField="email" dataSort={true}>
        Email
      </Column>,
      <Column
        key="role"
        dataField="role"
        dataSort={true}
        dataFormat={this._formatRole}
        sortFunc={UserListPage._sortAccessLevel}
      >
        Access Level
      </Column>,
      <Column
        key="networks"
        dataField="networks"
        dataSort={false}
        dataFormat={this._formatNetworks}
      >
        Networks
      </Column>,
    ];

    if (isAdmin) {
      columns.push(
        <Column
          key="operations"
          dataField="operations"
          dataFormat={this._formatOperations}
        >
          Operations
        </Column>,
      );
    }

    return columns;
  }

  _renderView() {
    const { storesLoaded, users } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    return (
      <Table
        data={users}
        hover={true}
        options={this.tableOpts}
        pagination={true}
        search={true}
        exportFile={"user-list.csv"}
        exportFunc={() => {
          return this._extractUserData(users);
        }}
      >
        {this._renderColumns()}
      </Table>
    );
  }

  _extractUserData(users) {
    const { networks } = this.props;
    const headers = ["Name", "Email", "Access Level", "Networks"];

    const userData = users.map((user) => {
      let networksStr = "";

      if (isArray(user.networks)) {
        const userNetworks = user.networks.map((networkId) =>
          get(networks, `${networkId}.name`, ""),
        );
        networksStr = userNetworks.join(", ");
      }

      return [
        user.name || "",
        user.email || "",
        getRoleProp(user).label,
        Users.isAdmin(user) ? "All Networks" : networksStr,
      ];
    });

    return [headers, ...userData];
  }

  render() {
    const view = this._renderView();
    const { user } = this.props;

    if (!Users.isFullAdmin(user)) {
      return <Redirect to="/404" />;
    }

    return (
      <Page title="User List">
        <Box title="" noHeader={true}>
          {view}
        </Box>
      </Page>
    );
  }
}

export { UserListPage, UserRole };
